module.exports = __webpack_public_path__ + "media/Apple_Health_badge_US-UK_blk_sRGB-8056cc64.svg";